<script>
	import "../node_modules/@fortawesome/fontawesome-free/css/all.min.css";
	import "../node_modules/@fortawesome/fontawesome-pro/css/all.min.css";

	import LandingPage from './pages/LandingPage.svelte';
	import { Router, Route, Link} from 'svelte-routing';
	import EndpointsLayout from './pages/EndpointsLayout.svelte';
	import Endpoints from './pages/Endpoints.svelte';
	import Deployment from './pages/Deployment.svelte';
	import Commands from './pages/Commands.svelte';
	import Logout from './pages/Logout.svelte';
	import Navbar from './layout/SideNavbar.svelte';
	import TopNavbar from './layout/TopNavbar.svelte';
	import Packages from './pages/Packages.svelte';
	import Vessel from './pages/Vessel.svelte';
	import Computer from './pages/ComputerDashboard/Layout.svelte';
	import Credentials from './pages/Credentials.svelte';
	import Vessels from './pages/Vessels.svelte';
	import Home from './pages/Home.svelte';

	import { onMount } from 'svelte';
	import http from './api/http.js';
	import { setApiUrl, loggedIn, branding, currentPage } from './store.js';

	if (setApiUrl !== true) {
		window.apiBaseUrl = process.env.isProd
			? window.location.origin + "/" + process.env.PRODUCTION_API_URL
			: process.env.DEVELOPMENT_API_URL;
		setApiUrl.update((n) => true);
	}

	let activeLink = "";

	$: {
		$currentPage;
		if ($loggedIn) {
			activeLink = $currentPage;
		}
	}

	async function brandingPromise() {
		const result = await http.get("api/deploy/dashboard/brand");
		
		if (result.status == 200) {
			const brand = await result.json();
			branding.set(brand);
		}
	};
</script>

<svelte:head>
	<title>{$branding.name} Server</title>
	<link rel="shortcut icon" href="/themes/{$branding.theme}/favicon.png" type="image/x-icon" />
	<script src="https://cdnjs.cloudflare.com/ajax/libs/feather-icons/4.29.2/feather.min.js" integrity="sha512-zMm7+ZQ8AZr1r3W8Z8lDATkH05QG5Gm2xc6MlsCdBz9l6oE8Y7IXByMgSm/rdRQrhuHt99HAYfMljBOEZ68q5A==" crossorigin="anonymous" referrerpolicy="no-referrer"></script>
</svelte:head>
{#await brandingPromise()}
	<div></div>
{:then brandingPromiseComplete}
	{#if $loggedIn}	
		<div id="wrapper">
			<Router>
				<Navbar activeLink={activeLink}/>
				<div id="content-wrapper">
						<div id="context">
							<TopNavbar></TopNavbar>
							<div class="container">
								<Route path='/' component={Home} />
								<Route path='/vessels' component={Vessels} />
								<Route path='/vessel/:id' component={Vessel} />
								<Route path='/vessel/:id/:urlTab' component={Vessel} />
								<Route path='/computers' component={Endpoints} />
								<Route path='/endpointslayout' component={EndpointsLayout} />
								<Route path='/credentials' component={Credentials} />
								<Route path='/ComputerDashboard/layout/:computerId/:hostName' component={Computer} />
								<Route path='/deployment/:searchTerm' component={Deployment} />
								<Route path='/deployments' component={Deployment} />
								<Route path='/commands' component={Commands} />
								<Route path='/commands/:searchTerm' component={Commands} />
								<Route path='/packages' component={Packages} />								
								<!-- MIN-925 commented out to disable automation rules while system is stabilised -->
								<!-- <Route path='/automation' component={Automation} /> -->
								<Route path='/logout' component={Logout} />
							</div>
						
						</div>	
					</div>
				</Router>	
			</div>
		{:else}
		<LandingPage/>
	{/if}
{/await}

<style>
	#context{
		height:100vh;
		margin-left: 100px;
		transition: all 0.3s ease;
	}
</style>
	
